export default "__VITE_ASSET__DWE$iNLf__"